import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface AccessService {
  canModifyCustomFields$?: Observable<boolean>;
  hasPartnerViewAccess$?: Observable<boolean>;
}

export const SALES_ORDERS_ACCESS_SERVICE_TOKEN = new InjectionToken<AccessService>(
  'App-specific access service for the sales orders table',
);
